import useApiPrivateClient from '../../../hooks/useApiPrivateClient';
import { CreatePartnerData, UpdatePartnerData } from './partner.requests';
import { Partner } from './partner.responses';

const usePartnerService = () => {
  const api = useApiPrivateClient();

  const listPartners = () => api.get<Partner[]>('/partners');

  const getPartner = (id: string) => api.get<Partner>(`/partners/${id}`);

  const createPartner = (data: CreatePartnerData) =>
    api.post<Partner>('/partners', data);

  const updatePartner = (id: string, data: UpdatePartnerData) =>
    api.patch<Partner>(`/partners/${id}`, data);

  const deactivatePartner = (id: string) =>
    api.delete<Partner>(`/partners/${id}`);

  return {
    listPartners,
    getPartner,
    createPartner,
    updatePartner,
    deactivatePartner,
  };
};

export default usePartnerService;
